export const environment = {
  production: false,
  envName: 'uat'
};
